module.exports = __webpack_public_path__ + "static/media/arrow-up.d1cf9bc6.svg";